import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, purple } from '../colors';
import { buildPaletteForMode, type PaletteTokenMetadata, type Token } from '../panw-palette/token-metadata';

const newColorTokens = [
  { propertyPath: 'main', tokenName: '--data-informative-new' },
  { propertyPath: 'highContrast', tokenName: '--data-informative-new-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--data-informative-new-low-contrast' },
] satisfies Token[];

export const newColorMetadata: PaletteTokenMetadata = {
  componentName: 'status-new',
  tokens: newColorTokens,
};

export const newColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(newColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: purple[500],
        highContrast: purple[700],
        lowContrast: purple[100],
      }
    : {
        main: purple[400],
        highContrast: purple[100],
        lowContrast: purple[800],
      };
};
